import { isAxiosError } from 'axios';
import { z } from 'zod';

/** The `code`s workspace-api puts on a refused row write. Anything else reads as unknown. */
export const TRACKER_ROW_WRITE_ERROR_CODES = [
  'record_edit_forbidden',
  'tracker_view_only',
  'invalid_field_value',
  'start_date_after_deadline',
  'asset_name_taken',
  'row_not_found',
  'tracker_item_archived',
] as const;

export type TrackerRowWriteErrorCode = (typeof TRACKER_ROW_WRITE_ERROR_CODES)[number];

const refusalSchema = z.object({ code: z.enum(TRACKER_ROW_WRITE_ERROR_CODES) });

/** Why the server refused a row write, or `null` when it did not say in a way we know. */
export function trackerRowWriteErrorCode(error: unknown): TrackerRowWriteErrorCode | null {
  if (!isAxiosError(error)) return null;
  const parsed = refusalSchema.safeParse(error.response?.data);
  return parsed.success ? parsed.data.code : null;
}
